import script from "./GoToTopButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GoToTopButton.vue?vue&type=script&setup=true&lang=js"

import "./GoToTopButton.vue?vue&type=style&index=0&id=3be3fe86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be3fe86"]])

export default __exports__